module.exports = __webpack_public_path__ + "3444199164107eccca29e023fcc6996c.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-condensed-italic-webfont.woff
// module id = 441
// module chunks = 0